import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {ReactComponent as SuccessImage} from "../../assets/success.svg"
import { useTheme } from "@mui/material/styles";

const ExecutiveTemplateSuccessConfirmationDialog = ({ open, onConfirmClose, onYes}: any) => {
  const theme = useTheme();
  const colors = theme.palette;

  return (
    <Dialog
      open={open}
      onClose={onConfirmClose}
      PaperProps={{
        sx: {
          backgroundColor: colors.modal.bg, 
          color: colors.modal.text,
          width: "400px", 
          borderRadius: "8px",
        },
      }}
    >
      {/* Header Section */}
      <DialogTitle
        sx={{
            bgcolor: 'primary.main',
            color: 'white.main',
            p: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
      >
         <span>
    Successfully Submitted
  </span>
        <IconButton onClick={onConfirmClose} sx={{ color: 'white.main',}}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content Section */}
      <DialogContent sx={{ textAlign: "center", padding: "20px", backgroundColor: colors.modal.bg, color: colors.modal.text }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                <SuccessImage style={{width: 60, height: 60, padding: 8, marginTop: 8}}/>
                <Box textAlign="left">
                    <Typography variant="h6" sx={{ marginTop: "10px", color: colors.modal.text }}>
                        Dashboard Configuration has been successfully submitted to the Pepwise DL.
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.8, color: colors.modal.text }}>
                        Would you like to configure more Dashboards?
                    </Typography>
                </Box>
            </Box>
        </DialogContent>

      {/* Actions Section */}
      <DialogActions sx={{ justifyContent: "flex-end", padding: "20px", backgroundColor: colors.modal.bg }}>
        <Button
          onClick={onConfirmClose}
          sx={{
            color: colors.buttons.primary.textColor,
            fontWeight: "bold",
            textTransform: "uppercase"
          }}
        >
          CONFIRM & CLOSE
        </Button>
        <Button
          variant="pepwiseSecondary"
          onClick={onYes}
          sx={{ textTransform: "uppercase"}}
        >
          YES
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExecutiveTemplateSuccessConfirmationDialog;